import React, { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { AdminPagesService, useReturnCurrentPageType } from './adminPagesSlice'
import PageHeadSection from './components/PageHeadSection'
import AdminDynamicCreateOrUpdatePage from './AdminDynamicCreateOrUpdatePage'


interface IBaseDynamicPageProps {
    children: ReactNode
}
const BaseDynamicPage: React.FC<IBaseDynamicPageProps> = ({ children, ...props }) => {

    const params = useParams()
    
    return(
        <div className="admin-dynamic-page-container">
            <PageHeadSection pageName={params.page_name ? params.page_name : ""} />

            <div className="content-of-admin-dynamic-page-container">
                {children}
            </div>
        </div>
    )
}

export default function AdminDynamicPage() {

    const params = useParams()
    const page = AdminPagesService.usePageDetails(params.page_name ? params.page_name : "")
    const type = useReturnCurrentPageType()

    const itemId = params.id ? Number(params.id) : 0

    if (page.appClass){

        switch(type){

            case "new":

                if (page.appClass.redux){
                    if (page.appClass.redux.updateItem){
                        return <AdminDynamicCreateOrUpdatePage updateItem={page.appClass.redux.updateItem} />
                    }
                }

                if (page.appClass.pages?.createOrUpdate){
                    return <BaseDynamicPage><page.appClass.pages.createOrUpdate /></BaseDynamicPage>
                }
                return <></>

            case "edit":

                if (page.appClass.redux){
                    if (page.appClass.redux.updateItem){
                        return <AdminDynamicCreateOrUpdatePage updateItem={page.appClass.redux.updateItem} />
                    }
                }

                if (page.appClass.pages?.createOrUpdate){
                    return <BaseDynamicPage><page.appClass.pages.createOrUpdate isUpdate={true} itemId={itemId} /></BaseDynamicPage>
                }
                return <></>            

            default:
                return <></>
        }
    }

    return <></>

}